export default __webpack_public_path__ + "static/media/shoe06.350af268.jpg";